import {JsonApiError} from '@/utils/jsonapiClient';
import translate from '@/utils/translate';

export default function classifyNegotiationError(error: unknown) {
  const isNegotiationNotAllowed =
    error instanceof JsonApiError && error.status === 409;
  return {
    isNegotiationNotAllowed,
    subtitle: isNegotiationNotAllowed
      ? translate('Negotiation is not allowed for this campaign.')
      : '',
  };
}
